import React from "react";
import { redirectToUrl } from "../../Utils/StayUpToDate/RenderComponent";
import { BsHourglassSplit } from "react-icons/bs";
import Card from "react-bootstrap/esm/Card";
import EllipsisTooltipText from "../ProductName/EllipsisTooltipText";

const ImagePostTagLocal = React.memo((props: any) => {
  const { data, isLinks, key, isPodcast, brand_color, component, content_shape, isYoutube } =
    props;

  const { thumbnail, media_url, shop_link, post_id, caption, permalink } = data;
  // const redirectUrl = !isLinks
  //   ? data?.permalink || data?.shop_link || data?.table_url
  //   : data?.shop_link || data?.table_url || data?.permalink;
  const redirectUrl: any = redirectToUrl(data, isLinks);
  const getWrapperClassName = () => {
    const baseClass = isPodcast
      ? "creator-feed-image-wrapper-pod-subcomponents"
      : "creator-feed-image-wrapper-links-subcomponents";
    const classes = [baseClass];

    if (component?.content_shape == "sq" || content_shape == "sq") classes.push("square-wrapper");
    else if (isYoutube) classes.push("youtube-feed-wrapper");
    // else if (!data?.media_url) classes.push("not-available");
    return classes.join(" ");
  };

  const getImageClassName = () => {
    const baseClass = isPodcast
      ? "creator-feed-image-wrapper-podcast-subcomponents"
      : "creator-feed-card-links-image-subcomponents";
    const classes = [baseClass];

    if (component?.content_shape == "sq" || content_shape == "sq") classes.push("square-image");
    else if (isYoutube) classes.push("youtube-feed-height");

    return classes.join(" ");
  };
  return (
    <a
      href={redirectUrl}
      target="_blank"
      style={{ textDecoration: "none" }}
      rel="noopener noreferrer" // It's a good practice to add this for security reasons
    >
      <>
        {!media_url ? (
          <div className="creator-feed-card-links-subcomponents not-available">
            <BsHourglassSplit className="hourglassSplit" />
            <p>
              Work in progress: This content will be available in a few minutes.
            </p>
          </div>
        ) : (
          <>
            {isPodcast ? (
              <div
                className={getWrapperClassName()}
                style={{
                  backgroundColor: brand_color && brand_color,
                  boxShadow: brand_color && `0px 0.325rem 0px 0px ${brand_color}`
                }}
              >
                <div className={getImageClassName()}>
                  <Card.Img
                    variant="top"
                    src={media_url.includes("video") ? thumbnail : media_url}
                    style={(component?.content_shape == "sq" || content_shape == "sq") ? { width: "80px", height: "80px", borderRadius: "4px" } : { height: "auto" }}
                    className={`creator-feed-card-podcast-image ${(component?.content_shape == "sq" || content_shape == "sq") ? "podcast-image" : ""}`}
                    loading="eager"
                  />
                  {/* <h4 className="caption">{caption}</h4> */}
                  <EllipsisTooltipText className={`caption ${(component?.content_shape == "sq" || content_shape == "sq") && "podcast-text-square"}`} text={caption} />
                </div>
              </div>
            ) : (
              <div className={getWrapperClassName()}>
                <Card.Img
                  variant="top"
                  src={media_url.includes("video") ? thumbnail : media_url}
                  className={getImageClassName()}
                  loading="eager"
                  style={{
                    backgroundColor: brand_color,
                    // boxShadow: brand_color && `0px 0.325rem 0px 0px ${brand_color}` 
                  }}
                />
              </div>
            )}
          </>
        )}
      </>
    </a>
  );
});

export default ImagePostTagLocal;
